module.exports = __webpack_public_path__ + "static/media/pdfIcon.f92fde3c.png";